module.exports = __webpack_public_path__ + "img/hungary.c9edc6a6.svg";